import { uniq } from 'lodash-es'
import countries, { parseCountry } from './countries'

export const defaultCurrency = 'USD'
export const defaultCurrencySymbol = '$'
export function countryToCurrency(countryIsoOrName) {
    return parseCountry(countryIsoOrName)?.currencyCode || defaultCurrency
}

const currencies = uniq(countries.map((c) => c.currencyCode).filter(Boolean))
export default currencies
